import styled from 'styled-components';

export const Text = styled.p`
  font-size: var(--font-size15);
  font-weight: var(--font-weight400);
  color: var(--color-grey6A);
  margin: 0 0 20px 240px;
`;
